import React, { FC } from 'react'
import { Text, Box } from '@moonpig/launchpad-components'
import { useExperiment } from '@moonpig/web-core-eppo/browser'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'
import { useSellingPoints } from './useSellingPoints'

const StyledList = styled.ul`
  list-style: disc;
  ${s({ ml: 6 })}
`

export const FlowersUSPContent: FC<{ isPlant: boolean }> = ({ isPlant }) => {
  const sellingPoints = useSellingPoints(isPlant)

  const isEnabled =
    useExperiment('cvr-flowers-usp', { fallback: 'control' }) === 'variant'

  if (!isEnabled) {
    return null
  }

  return (
    <StyledList>
      {sellingPoints.map((point, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <Box key={index} as="li" ml={2} mb={2}>
          <Text
            typography={{ xs: 'typeBodyText', md: 'typeBodyLead' }}
            fontWeight={400}
          >
            <Text dangerouslySetInnerHTML={{ __html: point.description }} />
          </Text>
        </Box>
      ))}
    </StyledList>
  )
}
